import { useEffect, useState } from "react";

const useResponsiveRadius = (containerRef) => {
    const [radius, setRadius] = useState({ inner: 65, outer: 100 });

    useEffect(() => {
        if (!containerRef.current) return;

        const calculateRadius = (element) => {
            const rect = element.getBoundingClientRect();
            const outerRadius = 0.43 * rect.height;
            const innerRadius = 0.7 * outerRadius;
            return { inner: innerRadius, outer: outerRadius };
        };

        // Set initial radius with a small delay to ensure layout is complete
        const setInitialRadius = () => {
            if (containerRef.current) {
                setRadius(calculateRadius(containerRef.current));
            }
        };

        // Try immediately
        setInitialRadius();
        
        // Also try after a small delay as fallback
        const timeoutId = setTimeout(setInitialRadius, 100);

        const handleResize = (entries) => {
            for (let entry of entries) {
                const { height } = entry.contentRect;
                const outerRadius = 0.43 * height;
                const innerRadius = 0.7 * outerRadius;
                setRadius({ inner: innerRadius, outer: outerRadius });
            }
        };

        const observer = new ResizeObserver(handleResize);
        observer.observe(containerRef.current);

        return () => {
            observer.disconnect();
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return radius;
};

export default useResponsiveRadius;